import Moralis from "moralis";

export const ProfileObject = Moralis.Object.extend("Profile");
export const MessageObject = Moralis.Object.extend("Message");
export const ChatObject = Moralis.Object.extend("Chat");
export const PostObject = Moralis.Object.extend("Post");
export const OfferObject = Moralis.Object.extend("Offer");
export const ContractObject = Moralis.Object.extend("Contract");
export const NotificationsObject = Moralis.Object.extend("Notifications");
